module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-vo-638196eb.svg";